import CallCenterForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    CallCenterForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('smsTemplates.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.smsTemplates.show(this.$route.params.id).then(response => {
        this.data = response
        this.ready = true

        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.smsTemplates.index'), route: {name: 'sms-templates-index'}},
          {label: this.$t('breadcrumbs.smsTemplates.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateCallCenter(data) {
      API.smsTemplates.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('smsTemplates.edit.succesfullyUpdated'))
        this.$router.push({name: 'sms-templates-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
